//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Emitter from '@/mixins/emitter';
import { isFilter, isProperty, valueEquals } from '../../../helpers/util';
import DpIcon from '../icon/Icon.vue';
import DpTooltip from '../modal/Tooltip.vue';

export default {
  name: 'DpOption',
  components: {
    DpIcon,
    DpTooltip,
  },
  mixins: [Emitter],
  props: {
    label: { type: null, required: true },
    val: { type: null, required: true },
    icon: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    disabledTooltip: { type: String, default: null },
    editable: { type: Boolean, default: false },
    tooltip: { type: String, default: null },
    hideTitle: { type: Boolean, default: false },
  },
  data() {
    return {
      select: null,
      selected: false,
      visible: true,
      focused: false,
    };
  },
  computed: {
    calculatedTooltip() {
      if (this.disabled) {
        return this.disabledTooltip || this.$t('ui.disabledTimeFilter');
      }
      if (this.tooltip) {
        return this.tooltip;
      }
      return null;
    },
    isSelected() {
      if (this.select && valueEquals(this.select.value, this.val)) {
        return true;
      }
      return false;
    },
    isFilter() {
      return isFilter(this.val);
    },
    isProperty() {
      return isProperty(this.val);
    },
    isEditable() {
      return this.editable;
    },
  },
  mounted() {
    let parent = this.$parent;
    while (parent) {
      if (parent.$options.name !== 'DpSelect') {
        parent = parent.$parent;
      } else {
        this.select = parent;
        break;
      }
    }

    if (!this.select) {
      return;
    }

    this.select.registerOption(this);
    this.$on('queryChange', this.handleQueryChange);
    this.$on('focusChange', this.handleFocusChange);
  },
  methods: {
    edit() {
      if (!this.val && !this.val.id) {
        return;
      }
      this.$emit('edit', this.val);
    },
    selectOption() {
      if (this.disabled === true) {
        return;
      }
      this.dispatch('DpSelect', 'handleOptionClick', this);
      this.$emit('select', this);
    },
    handleQueryChange(query) {
      let checkedFields = [];
      if (this.isFilter) {
        checkedFields = [this.label, this.val.id, this.val.name];
      } else if (this.isProperty) {
        checkedFields = [this.label, this.val.name, this.val.alias];
      } else {
        checkedFields = [this.label, this.val];
      }

      let hasMatch = false;
      checkedFields.forEach((f) => {
        if (`${f}`.toLowerCase().indexOf(`${query}`.toLowerCase()) !== -1) {
          hasMatch = true;
        }
      });

      if (hasMatch) {
        this.visible = true;
      } else {
        this.visible = false;
      }
    },
    handleFocusChange(option) {
      if (valueEquals(option.val, this.val)) {
        this.focused = true;
      } else {
        this.focused = false;
      }
    },
  },
};
